import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '../../../typography';
import { getWebUrl } from '../../../../utilities/browser';
const NotificationError = () => (_jsxs(_Fragment, { children: ["De inloggegevens kloppen niet. Probeer je in te loggen bij", ' ', _jsx(Typography, { variant: "link-text", href: `https://${getWebUrl()}/zakelijk/mijn-anwb-voor-de-zaak/#/login`, target: "_parent", children: "Mijn ANWB voor de zaak" }), "?"] }));
export default NotificationError;
